import { OddsButton } from '@/components/widgets/odds-button';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { DisplayLineInfo, getDisplayLineInfo } from '@/utils/odds-utils';
import { Box } from '@nf/utils-common/fpw/monadic';
import { stringEmptyCheck } from '@nf/utils-common/fpw/utils';
import { useGetBetTypeSetting, useGetChoiceTitle } from '@/hooks';

export const BetTypeCol2 = ({ matchModel, betTypeArray, childMatchTeamNameMap }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const t = useTranslations('General');

	const { user } = useAccountInfo();
	const oddsData = useAtomValue(oddsPageAtom);

	const market = betTypeArray[0];
	const betTypeId = market.BetTypeId;
	const getChoiceTitle = useGetChoiceTitle(betTypeId);

	const { betChoices } = getBetTypeSetting(betTypeId, matchModel.GameID);
	const sortedBetTypeArray =
		matchModel?.GameID === 43 ? betTypeArray.sort((a, b) => {
			if (a.sort != b.sort) {
				return a.sort - b.sort;
			} else {
				return Number(a.Line) - Number(b.Line);
			}
		}) : betTypeArray.sort((a, b) => a.sort > b.sort ? 1 : -1);

	const getTranslatedLine = ({ prefixLabel, displayLine }: DisplayLineInfo) => stringEmptyCheck(prefixLabel)
		.fold(
			() => displayLine,
			(label: string) => `${t(label)}${displayLine}`
		);

	return (
		<div className="bettype__content bettype__content--col-2">
			<div className="bettype__list">
				{
					betChoices.map(choice => (
						<div key={choice.betTeam} className="bettype__title">
							{getChoiceTitle({ choice, market, match: matchModel, teamMap: childMatchTeamNameMap ?? oddsData?.teamNameMap })}
						</div>
					))
				}
			</div>
			{
				sortedBetTypeArray.map(market =>
					<div key={market.MarketId} className="bettype__list">
						{
							betChoices.map((choice) => {
								const line = Box.of({
									line: market.Line,
									betType: market.BetTypeId,
									betTeam: choice.betTeam
								})
									.map(getDisplayLineInfo)
									.map(getTranslatedLine)
									.extract();

								return (
									<OddsButton
										key={`${market.Line}_${choice.betTeam}`}
										match={matchModel}
										market={market}
										selection={market.Selections[choice.betTeam]}
										homeTeamName={''}
										awayTeamName={''}
										goal={line}
										variant="center"
										betTeam={market.Selections[choice.betTeam].SelId}
										originalPrice={market.Selections[choice.betTeam].Price}
										sport={matchModel?.GameID}
										type="OU"
										oddsType={user?.OType}
										accountStatus={user?.ActStatus ?? 0}
									/>
								)
							})
						}
					</div>
				)
			}
		</div>
	)
};
